import cookies from "vue-cookies";
import {base_url} from "@/main";

const API_URL = process.env.VUE_APP_API_URL;

async function customFetch(endpoint, options = {}, showErrors = true) {
    const token = `Bearer ${cookies.get("auth-token-behfam")}`;

    const defaultHeaders = {
        'Accept': 'application/json',
        ...(token && { 'Authorization': token })
    };

    if (!(options.body instanceof FormData)) {
        defaultHeaders['Content-Type'] = 'application/json';
    }

    const defaultOptions = {
        method: 'POST',
        credentials: 'include',
        headers: defaultHeaders,
        ...options,
    };

    if (defaultHeaders['Content-Type'] === 'application/json' && typeof options.body === 'object') {
        defaultOptions.body = JSON.stringify(options.body);
    }

    const url = `${base_url}${endpoint}`;

    try {
        const response = await fetch(url, defaultOptions);

        if (!response.ok) {
            if (response.status === 422) {
                throw await response.json();
            } else {
                if (showErrors) {
                    console.log(`HTTP error! status: ${response.status}`);
                }
                throw new Error('عملیات با موفقیت انجام نشد!');
            }
        }

        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            return await response.json();
        } else {
            return await response.text();
        }
    } catch (error) {
        if (showErrors) {
            console.error('Fetch error:', error);
        }
        throw error;
    }
}

export default customFetch;
